import { useGetCategoriesQuery } from 'integration/resources/categories'

export const useCategoryList = () => {
  const { data } = useGetCategoriesQuery()

  return {
    data
  }
}
